// extracted by mini-css-extract-plugin
export default {"header":"index_header_wlquz clearfix","logo":"index_logo_dTPEs"};